<template>
  <div class='group-box' v-if="pink">
    <div class="qrcode-top" v-if="!pink.subject.isSingle">
      <h3>长按识别二维码</h3>
      <p>免费领取小学语文同步资料（全套）</p>
      <img :src="qrcodeDocs">
    </div>
    <!-- 拼团中 -->
    <div class="detail">
      <div class="title">仅差<span>{{ pink.needNum }}</span>人，快和好友一起来学习</div>
      <!-- 倒计时 -->
      <div class="count-down">
        离结束
        <van-count-down :time="pink.countDownSecond * 1000" @finish="countDownFinish" millisecond>
          <template v-slot="timeData">
            <span class="item">{{ timeData.days * 24 + timeData.hours }}</span>
            <span class="line">：</span>
            <span class="item">{{ timeData.minutes }}</span>
            <span class="line">：</span>
            <span class="item">{{ timeData.seconds }}</span>
            <span class="line">：</span>
            <span class="item">{{ parseInt(timeData.milliseconds / 100) }}</span>
          </template>
        </van-count-down>
      </div>

      <!-- 参与拼团的人 -->
      <div class="members">
        <div class="item active" v-for="(pinkedUser, index) in pink.users" :key="index">
          <img :src="pinkedUser.avatar ? pinkedUser.avatar : require('@/assets/icons/none.png')" />
        </div>
        <div class="item" v-for="index in pink.needNum" :key="pink.users.length + index">
          <img :src="require('@/assets/icons/none.png')" />
        </div>
      </div>

      <!-- 邀请好友-->
      <div class="invite-btns">
        <button class="invite" v-if="pink.isLeader || pink.isJoin" @click="inviteFriends">邀请好友参与拼团</button>
      </div>
      <div class="poster" @click="createPoster"><span>生成拼团海报</span></div>
      <FocusTip v-if="!pink.subject.isSingle"/>
      <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />
      <!-- 邀请弹框 -->
      <SharePopup :show="showInvite" :text="pink.subject.shareContent" @close="showInvite=false" />
    </div>

    <!-- 课程详情 -->

  </div>
</template>
<script>
import { getPinkInfoAndUserInfo } from './query.gql'
import FocusTip from '@/components/FocusTip'
// import PinkBottomBar from '@/components/PinkBottomBar'
// import Service from '@/components/Service'
import Poster from '@/components/Poster'
import SharePopup from '@/components/SharePopup'
export default {
  name: 'groupInvite',
  data() {
    return {
      user: '',
      pink: '', // 拼团信息
      showInvite: false, // 邀请好友
      showPosterPopup: false,
      wxShareLink: '',
      posterData: null,
      qrcodeDocs: ''
    }
  },
  components: {
    // Service,
    Poster,
    FocusTip,
    // PinkBottomBar,
    SharePopup
  },
  async mounted() {
    console.log('邀请页', location.href)
    console.log('拼团id', this.$route.params.id)
    await this.weixinAuth()
    this.loadData() // 获取拼团信息

    if (process.env.NODE_ENV !== 'production') {
      this.qrcodeDocs = 'http://mmcb-pub-static.mmcb.top/wdds-qrcode.png'
    } else {
      this.qrcodeDocs = 'http://mmcb-pub-static.mmcb.top/mmcb-qrcode-docs.png'
    }
  },
  methods: {
    loadData() {
      // 请求数据
      let self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getPinkInfoAndUserInfo,
        variables: {
          id: parseInt(self.$route.params.id)
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.pink = res.data.pink
        console.log(res)
        // 计算拼团成功还需人数
        self.pink.needNum = self.pink.peopleNum - self.pink.users.length
        if (self.pink.status === 'success') {
          window.location.replace(`${window.location.origin}/?#/group/${self.pink.id}/success`)
        } else if (self.pink.status === 'fail') {
          window.location.replace(`${window.location.origin}/?#/group/${self.pink.id}/fail`)
        }
        // 设置分享
        self.wxShareLink = `${window.location.origin}/?#/group/${self.pink.id}/share`
        // let title = self.pink.needNum > 0 ? `仅差${self.pink.needNum}人!${self.pink.subject.pinkShareTitle}` : self.pink.subject.pinkShareTitle
        let title = self.pink.subject.pinkShareTitle
        self.wechatShare({
          title: title,
          imgUrl: self.pink.subject.smallLogoImg,
          desc: self.pink.subject.pinkShareContent,
          link: self.wxShareLink
        })
        self.$toast.clear()
      }).catch(err => {
        console.error('page：group/invite。请求getPinkInfoAndUserInfo报错', err)
        self.$toast.fail('加载数据出错')
      })
    },
    // 倒计时结束
    countDownFinish() {
      this.$router.replace({
        name: 'groupFail',
        params: { id: this.pink.id }
      })
    },
    // 邀请好友
    inviteFriends() {
      this.showInvite = true

      // const self = this
      // self.$zhuge.track('拼团微信分享', {
      //   '课程名称': self.pink.subject.title
      // })
    },
    createPoster() {
      // 生成海报
      const self = this
      self.posterData = {
        user: {
          avatar: self.user.avatar,
          nickname: self.user.nickname
        },
        posterTplImg: self.pink.subject.posterTplImg,
        wxShareLink: self.wxShareLink
      }
      self.showPosterPopup = true

      // self.$zhuge.track('拼团生成海报', {
      //   '课程名称': self.pink.subject.title
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.group-box {
  .pink-success, .pink-fail, .detail {
    background: #fff;
    padding-bottom: 20px;
    .title {
      font-size: 17.5px;
      color: #333;
      padding: 20px 0 15px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      span {
        color: #fa512d;
        font-size: 21px;
        font-weight: bold;
      }
    }
    .count-down {
      font-size: 14px;
      padding-bottom: 17px;
      color: #4d4d4d;
      font-weight: bold;
      text-align: center;
      .van-count-down{
        display: inline;
        .item{
          color: #fff;
          display: inline-block;
          width: 27px;
          height: 27px;
          line-height: 27px;
          box-sizing: border-box;
          text-align: center;
          background-color: #666;
          border-radius: 5px;
        }
        .line{
          margin-left: 5px;
        }
      }
    }
    .members {
      overflow: hidden;
      padding-bottom: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: 50px;
        height: 50px;
        margin-right: 17.5px;
        padding: 2.5px;
        box-sizing: border-box;
        margin-top: 6px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        &.active {
          background: url('~@/assets/images/groupUserHasPayBg.png') no-repeat center / 100%;
        }
      }
    }
    .poster {
      padding-bottom: 14px;
      text-align: center;
      span {
        border-bottom: 1px solid #ff623b;
        font-size: 15px;
        line-height: 17.5px;
        color: #ff623b;
      }
    }
  }

  .invite-btns, .sticky-btns {
    height: 46.5px;
    padding-bottom: 7.5px;
    position: relative;
    .invite {
      font-size: 20px;
      height: 46.5px;
      width: 278px;
      line-height: 46.5px;
      font-weight: bold;
      text-align: center;
      margin: 0 auto;
      border-radius: 25px;
      color: #fff;
      position: absolute;
      left: 50%;
      margin-left: -139px;
      background: linear-gradient(to top, #ff4800,#ff9600);
      box-shadow: 0 0 8px #ff8f00;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-appearance: none;
      animation: pulse 1s infinite;
    }
  }

  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
    }
    .group {
      width: 58%;
      padding: 8px 0;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 48px;
        line-height: 80px;
        font-size: 18px;
        top: -15px;
        right: -50px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .normal-btn-box {
    display: flex;
    color: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 20px;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
      margin: 0 15px;
      border-radius: 28px;
    }
    .group {
      width: 45%;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      padding: 8px 0;
      margin: 0 15px;
      border-radius: 28px;
      position: relative;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 40px;
        line-height: 60px;
        top: -6px;
        right: -45px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .pay_box {
    font-size: 15.36px;
    border-radius: 9.6px 9.6px 0 0;
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    img {
      width: 100%;
    }
    .tab {
      overflow: hidden;
      height: 38.3906px;
      line-height: 38.3906px;
      padding: 0 26.88px;
      border-bottom: 0.46875px solid #f7f7f7;
      .img {
        padding-top: 9.6px;
        padding-right: 12.48px;
        width: 18.7188px;
      }
      .text {
        font-size: 17.28px;
        color: #333;
      }
      .name {
        font-size: 14.4px;
        color: #666;
        padding-right: 4.8px;
      }
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
      border: unset;
    }
  }
  .qrcode-top{
    padding: 10px;
    text-align: center;
    color: #333;
    line-height: 2em;
    font-size: 16px;
    h3{
      margin-bottom: 10px;
    }
    p{
        color: #fa512d;
    }
    img{
      display: inline-block;
      padding: 10px;
      width: 45%;
      border: 6px solid #ff623b;
    }
  }
}
</style>

<style>
#qrcode img {
  width: 100%;
  height: 100%;
}
</style>
